import {AUTHORITY_ENUM} from "@/shared/model";
import {z} from "zod";

const schema = z.object({
	id: z.string(),
	name: z.string(),
	position: z.string(),
	department: z.string(),
	authority: AUTHORITY_ENUM,
	firstLogin: z.boolean().nullable().default(false),
	gender: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeMeResModel = {schema, model};
export type IEmployeeMeResModel = z.infer<typeof EmployeeMeResModel.model>;
export const DEFAULT_EMPLOYEE_ME: IEmployeeMeResModel = {
	id: "",
	name: "",
	position: "",
	firstLogin: false,
	department: "",
	gender: "",
	authority: "PART_TIME"
};
